import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GlobalCfgService } from '../../services/globalcfg.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { EventBusService } from '../../services/event-bus.service';
import { MiscService } from '../../services/misc.service';
import { SidenavbarViewService } from '../../services/sidenavbar-view.service';

@Component({
  selector: 'rm-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit{

  @Input()
  hideActions: boolean = false;

  @Input()
  hideUserAction: boolean = false;

  @Input()
  showParticipantSelection: boolean = false;

  @Output()
  public navMenuClicked = new EventEmitter();

  selectedParticipant: any = 'all';

  participants: any[] = [];

  drawer: boolean = true;

  user: any;
  userSubscription: any;
  activityNotifications: any[] = [];
  meetingNotifications: any[] = [];
  subscriptions: any = [];
  role: any;

  viewLink: string = '';

  constructor(
    private router : Router, 
    private globalCfgService: GlobalCfgService,
    private authService: AuthService,
    private busService: EventBusService,
    private miscService: MiscService,
    private sidenavbarViewService: SidenavbarViewService
  ) {
    this.selectedParticipant = window.localStorage.getItem('selectedGcp');
    this.selectedParticipant = this.selectedParticipant == "null" ? 'all' : this.selectedParticipant;
  }

  ngOnInit() {
    let u = this.globalCfgService.getFullUserObj();
    if (!u) {
      this.userSubscription = this.globalCfgService.userFetchedValue$.subscribe(
        user => {
          if (user) {
            this.user = user;
          }

          var role = this.globalCfgService.getFullUserObj().role;
          this.viewLink = '/' + role + '/manage-profile';

          this.miscService.getOrganisations().subscribe(
            (response: any)=> {
              this.participants = response['data'];
            }
          );
        }
      );
      this.subscriptions.push(this.userSubscription);
    } else {
      this.user = u;

      var role = this.globalCfgService.getFullUserObj().role;
      this.viewLink = '/' + role + '/manage-profile';

      this.miscService.getOrganisations().subscribe(
        (response: any)=> {
          this.participants = response['data'];
        }
      );
    }

    this.subscriptions.push(
      this.busService.profilepicFetchedValue$.subscribe(userDetail => {
        this.user["photoUrl"] = userDetail["photoUrl"];
      })
    );

    this.subscriptions.push(
      this.busService.toggleDrawerValue$.subscribe(drawer => {
        this.drawer = drawer;
      })
    );
  }

  ngOnDestroy(){
		// prevent memory leak when component destroyed
		this.subscriptions.forEach(s => s.unsubscribe());
	}

  logout() {
    this.authService.logout().subscribe(
      (response) => {
        console.log('User logout successful!');
        this.globalCfgService.setLoggedInUser(null, null);
        this.sidenavbarViewService.childView = undefined;
        this.router.navigateByUrl('/');
      },
      (error) => {
        console.log(error);
        this.globalCfgService.setLoggedInUser(null, null);
      }
    );
  }

  onClick() {
    this.navMenuClicked.emit();
  }

  handleParticipantChange(e) {
    var gcp = e.value == 'all' ? null : e.value;
    window.localStorage.setItem('selectedGcp', gcp);
    this.busService.particpantSelectionSource.next(gcp);
  }

  toggleMenu() {
    this.drawer = !this.drawer
    this.busService.toggleDrawerSource.next(this.drawer);
  }
}
